/* ================================================================
   NEXT VAULT — Premium Search
   Desktop : Inline header expansion (no panel)
   Mobile  : Fullscreen popup with three-dot menu
   ================================================================ */
(function () {
  'use strict';

  /* ─── Desktop elements ─── */
  var header       = document.getElementById('st-header-main');
  var hdrSearch    = document.getElementById('st-hdr-search');
  var hdrInput     = document.getElementById('st-hdr-input');
  var hdrClear     = document.getElementById('st-hdr-sbar-clear');
  var hdrClose     = document.getElementById('st-hdr-sbar-close');
  var hdrDrop      = document.getElementById('st-hdr-drop');

  /* ─── Mobile elements ─── */
  var psrPanel     = document.getElementById('psr-panel');
  var psrBackdrop  = document.getElementById('psr-backdrop');
  var psrClose     = document.getElementById('psr-close');
  var psrInput     = document.getElementById('PsrInput');
  var psrClear     = document.getElementById('psr-clear');
  var psrResults   = document.getElementById('psr-results');
  var psrDefaults  = document.getElementById('psr-defaults');

  /* ─── State ─── */
  var deskTimeout   = null;
  var mobTimeout    = null;
  var deskQuery     = '';
  var mobQuery      = '';
  var abortCtrl     = null;

  /* ================================================================
     HELPERS
     ================================================================ */
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function thumbUrl(raw) {
    if (!raw) return '';
    var url = raw.replace(/^\/\//, 'https://');
    return url.replace(/(\.[a-z]{2,4})(\?|$)/i, '_80x80_crop_center$1$2');
  }

  function abortFetch() {
    if (abortCtrl) { try { abortCtrl.abort(); } catch (e) {} }
    abortCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
  }

  function loadImg(img) {
    var src = img.getAttribute('data-src');
    if (!src) return;
    img.onload  = function () { img.classList.add('loaded'); };
    img.onerror = function () {
      if (img.parentElement) img.parentElement.innerHTML =
        '<span class="srch-result-img-placeholder">&#x1F6CD;</span>';
    };
    img.src = src;
    img.removeAttribute('data-src');
  }

  function observeImages(container) {
    if (!container) return;
    var imgs = container.querySelectorAll('[data-src]');
    imgs.forEach(function (img) {
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { loadImg(e.target); obs.unobserve(e.target); } });
        }, { rootMargin: '100px' });
        obs.observe(img);
      } else {
        loadImg(img);
      }
    });
  }

  /* ─── Build shared result HTML ─── */
  function buildResultsHtml(products, q, isMob) {
    if (products.length === 0) {
      return '<div class="srch-no-results">'
        + '<strong>No results for &ldquo;' + escHtml(q) + '&rdquo;</strong>'
        + 'Try a different keyword.</div>';
    }

    var html = '<span class="srch-section-label">Products (' + products.length + ')</span>';

    products.forEach(function (p) {
      var img      = thumbUrl(p.featured_image ? p.featured_image.url : '');
      var price    = formatMoney(p.price);
      var cmpRaw   = p.compare_at_price_max || p.compare_at_price || 0;
      var compare  = (cmpRaw && cmpRaw > p.price) ? formatMoney(cmpRaw) : '';

      html += '<a href="/products/' + escHtml(p.handle) + '" class="srch-result-item">';
      html += '<div class="srch-result-img-wrap">';
      if (img) {
        html += '<img class="srch-result-img" data-src="' + escHtml(img) + '"'
          + ' alt="' + escHtml(p.title) + '" width="56" height="56">';
      } else {
        html += '<span class="srch-result-img-placeholder">&#x1F6CD;</span>';
      }
      html += '</div>';
      html += '<div class="srch-result-info">';
      html += '<p class="srch-result-title">' + escHtml(p.title) + '</p>';
      html += '<div class="srch-result-prices">';
      if (price)   html += '<span class="srch-result-price">'   + price   + '</span>';
      if (compare) html += '<span class="srch-result-compare">' + compare + '</span>';
      html += '</div></div></a>';
    });

    html += '<a href="/search?type=product&q=' + encodeURIComponent(q) + '" class="srch-view-all">'
      + 'View all results'
      + '<svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">'
      + '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>';

    return html;
  }

  /* ─── Fetch from Shopify Predictive Search API ─── */
  function fetchSuggestions(q, onSuccess, onError) {
    abortFetch();
    var opts = abortCtrl ? { signal: abortCtrl.signal } : {};
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=6'
      + '&resources[fields]=title,featured_image,price,compare_at_price,handle';

    fetch(url, opts)
      .then(function (r) { if (!r.ok) throw new Error('network'); return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        onSuccess(products);
      })
      .catch(function (err) { if (err.name !== 'AbortError') onError(err); });
  }

  /* ================================================================
     DESKTOP — Inline header search
     ================================================================ */
  function openDesktopSearch() {
    if (!header) return;
    header.classList.add('search-open');
    if (hdrSearch) {
      hdrSearch.setAttribute('aria-hidden', 'false');
      // Populate dropdown with defaults
      showDesktopDefaults();
    }
    setTimeout(function () { if (hdrInput) hdrInput.focus(); }, 60);
  }

  function closeDesktopSearch() {
    if (!header) return;
    header.classList.remove('search-open');
    if (hdrSearch) hdrSearch.setAttribute('aria-hidden', 'true');
    if (hdrDrop)   { hdrDrop.classList.remove('visible'); hdrDrop.innerHTML = ''; }
    if (hdrInput)  hdrInput.value = '';
    if (hdrClear)  hdrClear.hidden = true;
    deskQuery = '';
    if (deskTimeout) { clearTimeout(deskTimeout); deskTimeout = null; }
  }

  function showDesktopDefaults() {
    if (!hdrDrop) return;
    hdrDrop.innerHTML =
      '<div class="srch-drop-defaults">'
      + '<span class="srch-section-label" style="padding:0 0 8px;">Popular Searches</span>'
      + '<div class="srch-quick-links">'
      + '<a href="/collections/all">All Products</a>'
      + '<a href="/collections/new-arrivals">New Arrivals</a>'
      + '<a href="/collections/best-sellers">Best Sellers</a>'
      + '<a href="/collections/sale">On Sale</a>'
      + '</div></div>';
    hdrDrop.classList.add('visible');
  }

  function desktopSearch(q) {
    if (!hdrDrop) return;
    hdrDrop.innerHTML = '<div class="srch-loading"><div class="srch-spinner"></div></div>';
    hdrDrop.classList.add('visible');
    fetchSuggestions(q,
      function (products) {
        hdrDrop.innerHTML = buildResultsHtml(products, q, false);
        hdrDrop.classList.add('visible');
        observeImages(hdrDrop);
      },
      function () {
        hdrDrop.innerHTML = '<div class="srch-no-results"><strong>Something went wrong</strong>Please try again.</div>';
      }
    );
  }

  /* Desktop: close dropdown when clicking outside */
  document.addEventListener('click', function (e) {
    if (!header || !header.classList.contains('search-open')) return;
    var inSearch  = e.target.closest('#st-hdr-search');
    var inDrop    = e.target.closest('#st-hdr-drop');
    var isTrigger = e.target.closest('.st-search-trigger');
    if (!inSearch && !inDrop && !isTrigger) closeDesktopSearch();
  });

  /* Desktop search close button */
  if (hdrClose) hdrClose.addEventListener('click', closeDesktopSearch);

  /* Desktop clear button */
  if (hdrClear) {
    hdrClear.addEventListener('click', function () {
      hdrInput.value = '';
      hdrInput.focus();
      hdrClear.hidden = true;
      showDesktopDefaults();
      deskQuery = '';
    });
  }

  /* Desktop input */
  if (hdrInput) {
    hdrInput.addEventListener('input', function () {
      var q = hdrInput.value.trim();
      if (hdrClear) hdrClear.hidden = q.length === 0;
      if (q.length < 2) { deskQuery = ''; showDesktopDefaults(); return; }
      if (q === deskQuery) return;
      deskQuery = q;
      if (deskTimeout) clearTimeout(deskTimeout);
      deskTimeout = setTimeout(function () { desktopSearch(q); }, 280);
    });

    /* Submit on Enter */
    hdrInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && hdrInput.value.trim()) {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(hdrInput.value.trim());
      }
      if (e.key === 'Escape') closeDesktopSearch();
    });
  }

  /* ================================================================
     MOBILE — Fullscreen popup
     ================================================================ */
  function openMobileSearch() {
    if (!psrPanel) return;
    if (psrBackdrop) psrBackdrop.classList.add('show');
    psrPanel.classList.add('open');
    psrPanel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (psrInput) psrInput.focus(); }, 80);
  }

  function closeMobileSearch() {
    if (!psrPanel) return;
    if (psrBackdrop) psrBackdrop.classList.remove('show');
    psrPanel.classList.remove('open');
    psrPanel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (psrInput)   psrInput.value = '';
    if (psrClear)   psrClear.hidden = true;
    if (psrResults) psrResults.innerHTML = '';
    if (psrDefaults) psrDefaults.style.display = '';
    mobQuery = '';
  }

  if (psrClose)   psrClose.addEventListener('click', closeMobileSearch);
  if (psrBackdrop) psrBackdrop.addEventListener('click', closeMobileSearch);

  /* Mobile clear */
  if (psrClear) {
    psrClear.addEventListener('click', function () {
      psrInput.value = '';
      psrInput.focus();
      psrClear.hidden = true;
      if (psrResults)  psrResults.innerHTML = '';
      if (psrDefaults) psrDefaults.style.display = '';
      mobQuery = '';
    });
  }

  /* Mobile input */
  if (psrInput) {
    psrInput.addEventListener('input', function () {
      var q = psrInput.value.trim();
      if (psrClear) psrClear.hidden = q.length === 0;
      if (q.length < 2) {
        if (psrResults)  psrResults.innerHTML = '';
        if (psrDefaults) psrDefaults.style.display = '';
        mobQuery = '';
        return;
      }
      if (q === mobQuery) return;
      mobQuery = q;
      if (mobTimeout) clearTimeout(mobTimeout);
      mobTimeout = setTimeout(function () { mobileSearch(q); }, 280);
    });

    psrInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && psrInput.value.trim()) {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(psrInput.value.trim());
      }
    });
  }

  function mobileSearch(q) {
    if (!psrResults) return;
    if (psrDefaults) psrDefaults.style.display = 'none';
    psrResults.innerHTML = '<div class="srch-loading"><div class="srch-spinner"></div></div>';
    fetchSuggestions(q,
      function (products) {
        psrResults.innerHTML = buildResultsHtml(products, q, true);
        observeImages(psrResults);
      },
      function () {
        psrResults.innerHTML = '<div class="srch-no-results"><strong>Something went wrong</strong>Please try again.</div>';
      }
    );
  }

  /* ================================================================
     UNIFIED TRIGGER — routes to desktop or mobile version
     ================================================================ */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.st-search-trigger');
    if (!trigger) return;
    e.preventDefault();
    if (isMobile()) {
      openMobileSearch();
    } else {
      openDesktopSearch();
    }
  });

  /* Escape key closes whichever is open */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDesktopSearch();
    closeMobileSearch();
  });

})();
